import { maxFileSize, uploadFileOnS3 } from '~/helpers/upload';
import { useNavigate } from 'react-router-dom';
import { useGetConversationsQuery } from '~/data-provider';
import { conversationList, usePopup } from '~/helpers/store';
import { Toastr } from "~/helpers/toastr";

export default function PDFUpload() {
    const navigate = useNavigate();
    const cState = conversationList((state) => state);
    const pState = usePopup((state) => state);
    const upload = (e) => {
        pState.setShowProcessLoading(true);
        const files = e.target.files;
        uploadFileOnS3(files, (conversationId) => {
            e.target.value = "";
            cState.setConvoLoad(true);
            // data provider
            useGetConversationsQuery(cState.pageNumber).then((data) => {
                cState.setConversation(data['conversations']);
                cState.setConvoLoad(false);
            });
            navigate(`/chat/${conversationId}`);
        }, (data) => {
            e.target.value = "";
            let error_msg = "Something went wrong.<br>Please try again.";
            if(data?.showPopup) {
                pState.setShowPricingPopup(true);
                return;
            }
            if(data?.msg) error_msg = data.msg;
            Toastr.error(error_msg);
            pState.setShowProcessLoading(false);
        });
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (files.length > 0) {
            pState.setShowProcessLoading(true);
            uploadFileOnS3(files, (conversationId) => {
                cState.setConvoLoad(true);
                // data provider
                useGetConversationsQuery(cState.pageNumber).then((data) => {
                    cState.setConversation(data['conversations']);
                    cState.setConvoLoad(false);
                });
                navigate(`/chat/${conversationId}`);
            }, (data) => {
                let error_msg = "Something went wrong.<br>Please try again.";
                if(data?.showPopup) {
                    pState.setShowPricingPopup(true);
                    return;
                }
                if(data?.msg) error_msg = data.msg;
                Toastr.error(error_msg);
                pState.setShowProcessLoading(false);
            });
        }
    };
    return (
        <>
            <div className="upload-container max-w-[700px] m-auto bg-white border"
            onClick={
                ()=>{
                    const element = document.querySelector("#upload-image") as HTMLElement;
                    element.click();
                }
            }>
                <div className="upload-content border border-dashed"
                onDrop={handleDrop}
                onDragOver={(event) => {
                    const target = event.target as Element; // Cast to Element
                    if(!target.classList.contains('upload-content')) target.closest('.upload-content').classList.add('dragOver')
                    target.classList.add('dragOver')
                    event.preventDefault();
                } }
                onDragLeave={(event) => {
                    const target = event.target as Element; // Cast to Element
                    if(!target.classList.contains('upload-content')) target.closest('.upload-content').classList.remove('dragOver')
                    target.classList.remove('dragOver');
                    event.preventDefault();
                } }
                >
                    <input
                    id="upload-image"
                    type="file"
                    className='hidden'
                    onChange={upload}
                    accept="application/pdf"
                    />
                    <img
                        src="/assets/upload-pdf.png"
                        alt="Upload"
                        className="block dark:hidden m-auto my-2"
                    />
                    <div>Click or Drop PDF here</div>
                    <div style={{
                        fontSize: "12px",
                        color: "#89898A",
                        marginTop: "5px"
                    }}>File Format: PDF / Max File Size: {maxFileSize} MB</div>
                    <div className="upload-btn">
                        Upload PDF
                    </div>
                </div>
            </div>
        </>
    );
}